module.exports = o => o && o.__getValue;
